export const styles = {
  FlexStyle: {
    minH: "100vh",
    mt: { base: "-20px", md: "-80px" },
    justify: "flex-start",
    bg: "white",
    px: { base: 4, md: 12, lg: 60 },
    py: { base: 6, md: 10 },
  },
  BoxStyle: {
    border: "2px solid",
    borderColor: "#D53F8C",
    borderRadius: "2xl",
    p: { base: "10px", md: "40px", lg: "auto" },
    pt: "70px",
    pb: "80px",
    bg: "pink.50",
    ml: { base: "8px", md: "auto" },
    color: "gray.800",
    textAlign: "center",
    maxW: "1000px",
    w: "100%",
    boxShadow: "lg",
  },
  TextStyle: {
    fontSize: { base: "2xl", md: "3xl" },
    fontWeight: "extrabold",
    borderColor: "#D53F8C",
    letterSpacing: "wide",
    mb: 3,
  },
  subtitleStyle: {
    fontSize: { base: "sm", md: "md" },
    color: "gray.600",
    mb: 8,
  },
  cardHeading: {
    as: "h2",
    size: "lg",
    mb: 2,
    ml: "-24px",
    color: "pink.600",
  },
  institutionText: {
    fontSize: "lg",
    fontWeight: "semibold",
    ml: "-24px",
    mb: 1,
  },
  durationText: {
    fontSize: "md",
    color: "gray.500",
    ml: "-24px",
    mb: 1,
  },
  badge: {
    colorScheme: "pink",
    fontSize: "0.7em",
    ml: "-24px",
    mb: "8px",
    px: 2,
    py: 0.5,
  },
  descriptionText: {
    mb: 4,
    ml: "-24px",
  },
  sectionHeading: {
    fontSize: "lg",
    mt: 6,
    ml: "-25px",
    mb: 3,
    color: "pink.600",
  },
  softwareHeading: {
    fontWeight: "bold",
    fontSize: "lg",
    ml: "-25px",
    mb: 2,
    color: "pink.600",
  },
  synergyBox: {
    mt: 10,
    p: 6,
    bgGradient: "linear(to-r, pink.100, purple.100)",
    borderRadius: "lg",
    textAlign: "center",
  },
  synergyGrid: {
    columns: { base: 1, md: 3 },
    spacing: 6,
  },
  synergyItemTitle: {
    fontWeight: "bold",
    color: "pink.600",
    mb: 2,
  },
  CardContainer: {
    borderWidth: "1px",
    borderRadius: "xl",
    p: 6,
    textAlign: "center",
    cursor: "pointer",
    boxShadow: "md",
    transition: "all 0.3s",
    _hover: { boxShadow: "xl", transform: "scale(1.05)" },
  },
  ListStyle: {
    spacing: 1,
    fontSize: "10px",
    textAlign: "left",
    pl: 5,
  },
  ImageStyle: {
    boxSize: { base: "200px", lg: "170px" },
    objectFit: "cover",
    borderRadius: "full",
    mx: "auto",
    mt: { base: "30px", md: "-35px", lg: "-35px" },
    mb: { base: "-30px", md: "-30px", lg: "-10px" },
  },
  HobbieImageStyle: {
    boxSize: { base: "80px", lg: "100px" },
    objectFit: "cover",
    borderRadius: "full",
    mx: "auto",
    mt: "5px",
    mb: "5px",
  },
  container: {
    position: "relative",
    p: 0,
    maxW: "4xl",
    mx: { base: "auto", md: "auto" },
  },
  containerBox: {
    w: "100%",
    py: { base: 8, md: 16 },
  },
  heroWrapper: {
    direction: { base: "column", md: "row" },
    align: "center",
    justify: "center",
    gap: 8,
    px: { base: 4, md: 12 },
  },
  imageWrapper: {
    flexShrink: 0,
    mb: { base: 6, md: 0 },
  },
  image: {
    borderRadius: "2xl",
    w: { base: "200px", sm: "360px", md: "300px" },
    h: { base: "200px", sm: "360px", md: "300px" },
    objectFit: "cover",
    ml: "250px",
    mx: "auto",
  },
  headline: {
    fontSize: { base: "2xl", sm: "2xl", lg: "4xl" },
    fontWeight: "extrabold",
    color: "pink.600",
    mb: 3,
  },
  subHeadline: {
    fontSize: { base: "md", lg: "lg" },
    color: "gray.600",
    mb: 2,
  },
  tagline: {
    fontSize: { base: "sm", md: "md" },
    color: "gray.500",
  },
  sectionCard: {
    bg: "white",
    borderRadius: "xl",
    p: { base: 4, md: 6 },
  },
  skillsTitle: {
    fontSize: "2xl",
    fontWeight: "bold",
    color: "pink.600",
    mb: 4,
  },
  skillCard: {
    bg: "white",
    p: 4,
    borderRadius: "lg",
    boxShadow: "sm",
  },
  gradientHeading: {
    mb: 6,
    mt: "60px",
    textAlign: "left",
    bgGradient: "linear(to-r, pink.500, purple.500)",
    bgClip: "text",
  },
  sidebarContainer: {
    direction: { base: "row", md: "column" },
    w: { base: "100%", md: "250px", lg: "320px" },
    h: { base: "60px", md: "130vh" },
    bg: "gray.900",
    color: "white",
    p: 4,
    position: "fixed",
    top: 0,
    left: 0,
    align: "center",
    justify: { base: "space-between", md: "flex-start" },
    zIndex: 1000,
  },
  titleSection: {
    border: { base: 0, md: "2px solid #D53F8C" },
    borderRadius: "2xl",
    p: 4,
    mt: { base: 0, md: "100px" },
    mb: { base: 0, md: 8 },
    w: "100%",
    bg: { base: "transparent", md: "gray.800" },
    boxShadow: { base: "none", md: "lg" },
  },
  mobileTitleFlex: {
    display: { base: "flex", md: "none" },
    align: "center",
    justify: "space-between",
    w: "100%",
  },
  mobileTitleText: {
    fontSize: "lg",
    fontWeight: "extrabold",
    color: "#D53F8C",
    letterSpacing: "wide",
    ml: "12px",
  },
  mobileSubtitleText: {
    fontSize: "xs",
    color: "gray.300",
    fontStyle: "italic",
    ml: "12px",
  },
  earlybirdsIconMobile: {
    color: "#D53F8C",
    style: { fontSize: "2rem", minWidth: "40px" },
  },
  desktopTitleBox: {
    display: { base: "none", md: "block" },
    textAlign: "center",
  },
  earlybirdsIconDesktop: {
    color: "#D53F8C",
    style: { fontSize: "3rem", display: "block" },
  },
  desktopTitleText: {
    fontSize: "2xl",
    fontWeight: "extrabold",
    color: "#D53F8C",
    letterSpacing: "wide",
  },
  desktopSubtitleText: {
    fontSize: "sm",
    color: "gray.300",
    fontStyle: "italic",
  },
  desktopNavBox: {
    display: { base: "none", md: "block" },
    w: "100%",
  },
  desktopNavLink: {
    align: "center",
    pl: 2,
    mb: 5,
    w: "100%",
    fontSize: "sm",
    fontWeight: "medium",
    color: "gray.300",
    _hover: { color: "#D53F8C", transform: "translateX(4px)" },
    transition: "all 0.2s ease",
  },
  mobileMenuBox: {
    display: { base: "block", md: "none" },
  },
  menuList: {
    bg: "gray.800",
    borderColor: "gray.700",
    color: "gray.300",
    minW: "200px",
    mr: "-15px",
  },
  menuItem: {
    bg: "gray.800",
    color: "gray.300",
    fontSize: "xs",
    fontWeight: "medium",
    _hover: {
      color: "#D53F8C",
      bg: "gray.800",
      transform: "translateX(4px)",
    },
    _focus: { bg: "gray.700" },
    w: "100%",
    py: 3,
    borderBottom: "1px solid",
    borderColor: "gray.600",
  },
};
